import React, { useState } from 'react'
import { ContentModal } from 'ui/acro'
import { useModal_deprecated } from 'hooks'
import EventCalendarContent from 'components_v1/EventsView/EventCalendarContent'

function useEventAddToCalendar() {
  const [selectedEvent, setSelectedEvent] = useState(null)
  const modal = useModal_deprecated()

  const handleAddToCalendarClick = (event) => {
    setSelectedEvent(event)
    modal.open()
  }

  const AddToCalendarDialog = (
    <ContentModal
      style={{ maxHeight: 'unset', maxWidth: '650px', width: '80%' }}
      useModal={modal}
      overflow='hidden'
    >
      <EventCalendarContent event={selectedEvent} />
    </ContentModal>
  )

  return {
    handleAddToCalendarClick,
    AddToCalendarDialog
  }
}

export default useEventAddToCalendar
